import Tagify from "@yaireo/tagify";

// for initialising tagify manually
export const createTagify = (element) => {
  return new Tagify(element, {
    whitelist: JSON.parse(element.dataset.rawWhitelist),
    userInput: false,
    dropdown: {
      classname: "tags-look",
      maxItems: Infinity,
    },
  });
};

// for controllers/module/module_html/edit.html.heex
export function initialiseModuleCategoryMultiselect() {
  document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector('input[name="module_categories"]');
    input && createTagify(input);
  });
}
